import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();

  if (user === null) {
    return (
      <div
        className="min-h-screen flex items-center justify-center bg-[#050505]"
        data-testid="auth-loading-state"
      >
        <Loader2 className="h-6 w-6 text-[#00D2D3] animate-spin" />
      </div>
    );
  }

  if (user === false) {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
